// extracted by mini-css-extract-plugin
export default {"Select":"Select_Select__mAGBq","prefix":"Select_prefix__XC9jS","isInline":"Select_isInline__qosph"};